"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@mui/styles");
const useStyles = exports.useStyles = (0, _styles.makeStyles)(MUITheme => ({
  snetFooterContainer: {
    width: "100%",
    backgroundColor: MUITheme.palette.background.footer
  },
  snetFooter: {
    width: "80%",
    padding: 20,
    margin: "0 auto"
  }
}));